<template>
  <v-list-item
    :prepend-icon="!rightIcon ? prefixedIcon : ''"
    :append-icon="rightIcon ? prefixedIcon : ''"
    density="compact"
    nav
    @click="performAction($event)"
  >
    <v-list-item-title>{{ label }}</v-list-item-title>
  </v-list-item>
</template>

<script>
/**
 * Represents a menu item within the menu component.
 * @vue-prop {String} [icon = null] - Icon to be used for menu item.
 * @vue-prop {String} [label = String] - Label to display for menu item.
 * @vue-prop {Object} [route = { name: 'welcome' }] - Where to route menu item to.
 */
export default {
  props: {
    icon: {
      type: String,
      default: null,
    },
    rightIcon: {
      type: Boolean,
      default: false,
    },
    label: {
      type: String,
      default: '',
    },
    route: {
      type: Object,
      default: () => {
        return { name: 'welcome' };
      },
    },
    isAction: {
      type: Boolean,
      default: false,
    },
  },

  computed: {
    prefixedIcon() {
      return this.icon.startsWith('mdi') ? `mdi:${this.icon}` : this.icon;
    },
  },

  methods: {
    performAction(event) {
      if (this.isAction) this.doClientAction();
      else if (event.ctrlKey || event.metaKey) {
        window.open(this.$router.resolve(this.route).href, '_blank');
      }
      else this.$router.push(this.route);
    },

    doClientAction() {
      if (!this.isAction) return;
      const clientAction = this.$store.getters['menu/translateMenuAction'](this.route.name);
      if (!clientAction) {
        this.$store.dispatch('notify/push', {
          text: `Menu action "${this.route.name}" is not mapped properly. Please contact support.`,
          duration: -1,
        });
        return;
      }
      this.$store.dispatch(clientAction);
    },
  },
};
</script>
